export default __webpack_public_path__ + "static/media/slide15.f48ecd69.jpg";